// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQ_wrapper__1aMxG","qa_item":"FAQ_qa_item__H9_Wi","answer":"FAQ_answer__3Gbhy"};